import type { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import Seo from '../../components/seo';
import { isNoIndexPage } from '../../utils/is-no-index-page';
import type { CategoryInfo } from './api/getContentData';

interface AddCategorySeoProps {
    categoryInfo?: CategoryInfo;
}

const AddCategorySeo: FC<PropsWithChildren<AddCategorySeoProps>> = ({ categoryInfo, children }) => {
    const location = useLocation();
    const intl = useIntl();

    return (
        <>
            <Seo
                title={
                    categoryInfo?.response?.category?.pageTitle ??
                    intl.formatMessage({
                        id: 'category-search.title',
                        defaultMessage: 'Category Search',
                    })
                }
                description={categoryInfo?.response?.category?.pageDescription}
                keywords={categoryInfo?.response?.category?.pageKeywords}
                noIndex={isNoIndexPage(location?.pathname)}
            />
            {children}
        </>
    );
};

AddCategorySeo.defaultProps = {
    categoryInfo: undefined,
};

export { AddCategorySeo };
